import React, {Component} from 'react';
import {Input, Modal, AutoComplete, Button, Icon, Table, Popconfirm, message, Select} from 'antd';
import {Redirect} from 'react-router';
import './style.less';
import AddSn from './addsn';
import utils from '../../../utils/common';

const {Option} = AutoComplete;
const Opt = Select.Option;

const statusList = [{ lable: '全部', send_status: '' }, { lable: '已发货', send_status: '1' }, { lable: '待发货', send_status: '2' }]
class InventoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuData: [
        {id: 2, name: '硬件'},
        {id: 1, name: '软件'},
        {id: 3, name: '流量产品'}
      ],
      isActive: 0,
      isLoading: false,
      addvisible: false,
      id: null, // 要删除的库存的id
      goodsProperty: 2, // 2 硬件 1 软件
      storageList: [], // 库存列表
      goodsNameData: [], // 商品名称模糊搜索
      snData: [], // sn码模糊搜索
      pagination: {
        page_size: 10,
        current: 1,
        total: '',
        onChange: this.changePage
      },
      goods_name: null, // 搜索的商品名称
      device_sn: null, // 搜索的sn码
      send_status: '', // 状态查询
      activationCodeType: '', // 激活码类型
      activationCodeTypeData: [
        { label: '全部', value: '' },
        { label: '通用型', value: '0' }
      ],
    };
  }
  componentWillMount() {
    this.getStorageList(1, this.state.goodsProperty);
  }

  renderOption(item, index) {
    return (
      <Option key={item.name} text={item.name}>
        {item.name}
      </Option>
    );
  }

  // 获取库存列表
  getStorageList = (currentPage, property) => {
    let params = {
      page_num: 10,
      page_no: currentPage,
      goods_property: property,
      device_sn: this.state.device_sn,
      goods_name: this.state.goods_name,
      id: this.state.id,
      send_status: this.state.send_status,
      activation_code_type: this.state.activationCodeType
    };
    params = utils.dealElement(params);
    window.api('storage.query', params).then(res => {
      const pagination = {
        page_size: 10,
        current: Number(currentPage),
        total: Number(res.count),
        onChange: this.changePage
      };
      this.setState({storageList: res.storage_list, isLoading: false, pagination});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }

  // 删除库存
  delete = (id) => {
    window.api('storage.delete', {id}).then(() => {
      message.success('删除成功');
      this.getStorageList(this.state.pagination.current, this.state.goodsProperty);
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }

  // 改变tab的值
  selTap = async (id, index) => {
    let activationCodeTypeData;
    // 切换时，激活码类型默认值始终为"全部"（空字符串）
    const activationCodeTypeDefault = '';
    
    switch (index) {
      case 0:
        // 硬件
        activationCodeTypeData = [
          { label: '全部', value: '' },
          { label: '通用型', value: '0' }
        ];
        break;
      case 1:
        // 软件
        activationCodeTypeData = [
          { label: '全部', value: '' },
          { label: '通用型', value: '0' },
          { label: '联拓通道专属', value: '1' }
        ];
        break;
      default:
        // 流量产品
        activationCodeTypeData = [];
    }
    
    // 切换时，重置所有搜索条件为初始值
    await this.setState({
      goodsProperty: id,
      isActive: index,
      device_sn: null,
      goods_name: null,
      send_status: '',
      activationCodeType: activationCodeTypeDefault,
      activationCodeTypeData: activationCodeTypeData,
      storageList: [],
    });
    this.getStorageList(1, id);
  }

  // 按条件改变页面
  changePage = (page) => {
    page = page === 0 ? 1 : page;
    this.getStorageList(page, this.state.goodsProperty);
  }

  // 重置搜索条件
  resetFilter = () => {
    this.setState({
      goods_name: null,
      device_sn: null,
      send_status: '',
      activationCodeType: '',
    }, () => {
      this.getStorageList(1, this.state.goodsProperty);
    });
  }

  // 获取搜索信息
  getSearchInfo(type, value) {
    if (value === undefined) return;
    value = utils.deleteBlank(value);
    this.setState({[type]: value});
  }

  // 打开新增品牌弹框
  operationDialog = (type) => {
    const addvisible = type === 'open' ? Boolean(1) : Boolean(0);
    this.setState({addvisible});
    type === 'operation' ? this.getStorageList(this.state.pagination.current, this.state.goodsProperty) : null;
  }

  selectStatus = (type, value) => {
    this.setState({[type]: value});
  }
  
  bindValue = (type, e) => {
    if (type === 'send_status' || type === 'activationCodeType') {
      this.setState({[type]: e});
    } else {
      this.setState({[type]: e.target.value});
    }
  }

  render() {
    const {
      pagination, redirect, storageList, goodsProperty, addvisible, isActive, menuData, goodsNameData, snData, isLoading
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    
    const otherColumn = goodsProperty === 2 ? [{
      title: '设备sn码',
      key: 'device_sn',
      dataIndex: 'device_sn'
    }] : [
      {
        title: 'license',
        key: 'device_sn',
        dataIndex: 'device_sn'
      },
      {
        title: '有效期限(天)',
        key: 'expiry_date',
        dataIndex: 'expiry_date'
      },
    ];
    
    // 激活码类型列 - 只在硬件和软件时显示，流量产品不显示
    const activationCodeTypeColumn = isActive === 2 ? [] : [{
      title: '激活码类型',
      key: 'activation_code_type',
      dataIndex: 'activation_code_type',
      render: (codeType) => (
        codeType !== '' && codeType !== null ?
          (codeType === 0 ? '通用型' : codeType === 1 ? '联拓通道专属' : '')
          : ''
      ),
    }];
    
    const columns = [
      {
        title: '商品类型',
        key: 'goods_category_name',
        dataIndex: 'goods_category_name'
      },
      {
        title: '商品品牌',
        key: 'goods_brand_name',
        dataIndex: 'goods_brand_name'
      },
      {
        title: '商品名称',
        key: 'goods_name',
        dataIndex: 'goods_name'
      },
      ...otherColumn,
      ...activationCodeTypeColumn,
      {
        title: '设备唯一标识码',
        key: 'biz_tid',
        dataIndex: 'biz_tid'
      },
      {
        title: '状态',
        key: 'send_status',
        dataIndex: 'send_status',
        render: (status) => (
          Number(status) === 1 
            ? <span className="status-badge status-success">已发货</span>
            : <span className="status-badge status-warning">待发货</span>
        ),
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'operation',
        render: (record) => (
          <div className="opearte-blocks">
            <Popconfirm
              title="是否要删除？"
              onConfirm={() => this.delete(record.id)}
              okText="是"
              cancelText="否"
            >
              <span className="ml10">删除</span>
            </Popconfirm>
          </div>
        )
      }
    ];
    return (
      <div className="sn-blocks">
        {/* 新增终端码弹窗 */}
        {addvisible ? <Modal
          title="新增终端码"
          visible={addvisible}
          onCancel={this.operationDialog.bind(this, 'cancel')}
          footer={null}
          width="600px"
        >
          <AddSn
            onClick={this.operationDialog.bind(this, 'cancel')}
            addtionBrandEvent={this.operationDialog.bind(this, 'operation')}
          />
        </Modal> : null}
        
        {/* 表格上方导航栏 */}
        <div className="nav-items">
          <div className="tap-items">
            {
              menuData.map((item, index) => <span key={index} onClick={() => this.selTap(item.id, index)} className={isActive === index ? 'active' : ''}>{item.name}</span>)
            }
          </div>
          <Button type="primary" onClick={this.operationDialog.bind(this, 'open')}>新增sn码</Button>
        </div>
        <ul className="search-blocks">
          <li className="items">
            <label className="label-text">商品名称:</label>
            <AutoComplete
              className="certain-category-search"
              dropdownClassName="certain-category-search-dropdown"
              dropdownMatchSelectWidth={false}
              size="large"
              style={{width: '210px'}}
              dataSource={goodsNameData.map(this.renderOption)}
              placeholder="请输入商品名称"
              optionLabelProp="text"
              onBlur={this.getSearchInfo.bind(this, 'goods_name')}
              onSelect={this.getSearchInfo.bind(this, 'goods_name')}
              onChange={this.getSearchInfo.bind(this, 'goods_name')}
              value={this.state.goods_name}
              key={`goods_name-${isActive}`}
            >
              <Input suffix={<Icon type="search" className="certain-category-icon" />} />
            </AutoComplete>
          </li>
          <li className="items">
            <label className="label-text">sn码:</label>
            <AutoComplete
              className="certain-category-search"
              dropdownClassName="certain-category-search-dropdown"
              dropdownMatchSelectWidth={false}
              size="large"
              style={{width: '210px'}}
              dataSource={snData.map(this.renderOption)}
              placeholder="请输入sn码"
              optionLabelProp="text"
              onBlur={this.getSearchInfo.bind(this, 'device_sn')}
              onSelect={this.getSearchInfo.bind(this, 'device_sn')}
              onChange={this.getSearchInfo.bind(this, 'device_sn')}
              value={this.state.device_sn}
              key={`device_sn-${isActive}`}
            >
              <Input suffix={<Icon type="search" className="certain-category-icon" />} />
            </AutoComplete>
          </li>
          <li className="items">
            <label className="label-text">状态:</label>
            <Select 
              style={{width: '210px'}} 
              value={this.state.send_status} 
              onChange={this.selectStatus.bind(this, 'send_status')}
              key={`send_status-${isActive}`}
            >
              {
                statusList.map((item, index) => <Opt value={item.send_status} key={index}>{item.lable}</Opt>)
              }
            </Select>
          </li>
          {
            isActive !== 2 ? (
            <li className="items">
              <label className="label-text">激活码类型:</label>
              <Select 
                placeholder="选择激活码类型" 
                value={this.state.activationCodeType} 
                onChange={this.bindValue.bind(this, 'activationCodeType')} 
                style={{width: '210px'}}
                key={`activationCodeType-${isActive}`}
              >
                {
                  this.state.activationCodeTypeData.map((item, index) => (
                    <Opt key={index} value={item.value}>{item.label}</Opt>
                  ))
                }
              </Select>
            </li>
          ) : null}
          <li className="items reset-filter-btn">
            <Button type="primary" onClick={this.changePage.bind(this, 0)}>查询</Button>
            <Button onClick={this.resetFilter} style={{ marginLeft: 8 }}>重置</Button>
          </li>
        </ul>
        
        {/* 表格 */}
        <Table
          columns={columns}
          dataSource={storageList}
          pagination={pagination}
          className="table-box"
          rowKey={record => record.id}
          loading={isLoading}
          scroll={{x: 1000}}
        />
      </div>
    );
  }
}
export default InventoryList;



// WEBPACK FOOTER //
// ./src/containers/backEnd/inventoryMangement/inventorylist.jsx